import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect shorthand /n1 /n2 /n3 /n4 /n5 → /levels/n1 etc.
export const Route = createFileRoute('/$level')({
  beforeLoad: ({ params }) => {
    const valid = ['n1', 'n2', 'n3', 'n4', 'n5'];
    if (valid.includes(params.level.toLowerCase())) {
      throw redirect({ to: '/levels/$level', params: { level: params.level.toLowerCase() }, replace: true });
    }
  },
  component: () => null,
});
